// images
import blogImg1 from "../images/blog/spa.webp";
import blogImg2 from "../images/blog/yogaimage.webp";
import blogImg3 from "../images/blog/swiming-poll.webp";

import blogSingleImg1 from "../images/blog/img-4.webp";
import blogSingleImg2 from "../images/blog/img-5.webp";
import blogSingleImg3 from "../images/blog/img-6.webp";



const blogs = [
    {
        id: '1',
        title: 'Spa & Wellness',
        screens: blogImg1,
        description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Esse sint magni harum nihil voluptates, recusandae.',
        author: 'Loura Sweety',
        create_at: '25 Sep 2022',
        blogSingleImg:blogSingleImg1, 
        comment:'35',
        blClass:'format-standard-image',
    },
    {
        id: '2',
        title: 'Yoga and Meditation',
        screens: blogImg2,
        description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Esse sint magni harum nihil voluptates, recusandae.',
        author: 'David Luis',
        create_at: '23 Sep 2022',
        blogSingleImg:blogSingleImg2, 
        comment:'80',
        blClass:'format-standard-image',
    },
    {
        id: '3',
        title: 'Infinity Swimming Pool',
        screens: blogImg3,
        description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Esse sint magni harum nihil voluptates, recusandae.',
        author: 'Jenefer Willy',
        create_at: '21 Sep 2022',
        blogSingleImg:blogSingleImg3,
        comment:'95',
        blClass:'format-video',
    },
];
export default blogs;